import { render, staticRenderFns } from "./mailPadModal.vue?vue&type=template&id=58ba8294&"
import script from "./mailPadModal.vue?vue&type=script&lang=js&"
export * from "./mailPadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports